import React from "react";
import { Box, makeStyles, Paper } from "@material-ui/core";
import ParticipantUserProfile from "./ParticipantUserProfile";
import { getAuthInfo } from "store/slices/auth";
import { useSelector } from "react-redux";

const useStyles = makeStyles(() => ({
  container: {
    padding: "20px",
  },
  paper: {
    padding: "24px",
    borderRadius: "8px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
  },
  title: {
    fontSize: "20px",
    fontWeight: 700,
    color: "#111827",
    marginBottom: "24px",
  },
}));

const CreateParticipants = () => {
  const classes = useStyles();
  const authInfo = useSelector(getAuthInfo) || {};

  return (
    <Box className={classes.container}>
      <Paper className={classes.paper}>
        <ParticipantUserProfile isCreate={true} companyId={authInfo?.companyId} />
      </Paper>
    </Box>
  );
};

export default CreateParticipants;
